import { Link } from "gatsby"
import React from "react"
import { useState, useEffect } from "react"
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Image from "../image"

const isBrowser = () => typeof window !== "undefined"

const MobileFooter = props => {

  return(
    <div
      style={{
        background: `white`,
        borderTop: `1px solid darkgrey`,
        position: `fixed`,
        bottom: `0px`,
        left: `0px`,
        width: `100vw`,
        height:`48px`,
        zIndex: `9998`,
      }}>
      <Col xs="12" sm="12" md="12" lg="12" className='d-flex py-2 px-0' style={{alignItems:'center', height:'48px'}}>
        <div style={{width:'20%'}} >
          <Link to="/#all-trainings" >
            <div className="d-flex font-w500" style={{justifyContent: 'center'}} >
              {props.active_button == '' ?
                <Image src={'home_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} /> :
                <Image src={'home_inactive_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} />
              }
            </div>
          </Link>
        </div>
        <div style={{width:'20%'}} >
          <Link to="/eLearning" >
            <div className="d-flex font-w500" style={{justifyContent: 'center'}} >
              {props.active_button.includes('eLearning') ?
                <Image src={'elearning_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `32px`, height: `25px` }} type={`fluid`} /> :
                <Image src={'elearning_inactive_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `32px`, height: `32px` }} type={`fluid`} />
              }
            </div>
          </Link>
        </div>
        <div style={{width:'20%'}} >
          <Link to="/videos" >
            <div className="d-flex font-w500" style={{justifyContent: 'center'}} >
              {props.active_button.includes('videos') ?
                <Image src={'podcasts_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `28px` }} type={`fluid`} /> :
                <Image src={'podcasts_inactive_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} />
              }
            </div>
          </Link>
        </div>
        <div style={{width:'20%'}} >
          <Link to="/events" >
            <div className="d-flex font-w500" style={{justifyContent: 'center'}} >
              {props.active_button.includes('events') ?
                <Image src={'events_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `31px`, height: `30px` }} type={`fluid`} /> :
                <Image src={'events_inactive_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `32px`, height: `24px` }} type={`fluid`} />
              }
            </div>
          </Link>
        </div>
        <div style={{width:'20%'}} >
          <Link to="/update-profile" >
            <div className="d-flex font-w500" style={{justifyContent: 'center'}} >
              {props.active_button.includes('update-profile') ?
                <Image src={'profile_active_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} /> :
                <Image src={'profile_inactive_icon.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `25px`, height: `25px` }} type={`fluid`} />
              }
            </div>
          </Link>
        </div>
      </Col>
    </div>
  )
}

export default MobileFooter
